import { useCallback } from "react";
import { download } from "client_legacy/ndaw/fileDownloader";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";
import { AttachmentModel } from "client/Api/Email/email";
import {
	MailMessageLocationModel,
	MailMessageLocationQueryModel
} from "client/Api/Email/common";
import { convertToMailMessageLocationQueryModel } from "client/Features/Email/common";

export type SaveAttachmentAsHandlerOptions = {
	attachment: AttachmentModel;
	messageLocation: MailMessageLocationModel;
};

export function useDownloadAttachmentHandler(options: SaveAttachmentAsHandlerOptions): () => void {
	const {
		attachment: { exchangeAttachmentId },
		messageLocation
	} = options;

	const downloadAttachmentHandler = useCallback(
		(): void => {
			downloadAttachment(messageLocation, exchangeAttachmentId);
		},
		[exchangeAttachmentId, messageLocation]
	);

	return downloadAttachmentHandler;
}

function downloadAttachment(
	messageLocation: MailMessageLocationModel,
	attachmentId: string
) {
	const location: MailMessageLocationQueryModel = convertToMailMessageLocationQueryModel(messageLocation);

	const params: string = urlEncodeObject(
		{
			smtpAddress: location.smtpAddress,
			messageId: location.messageId,
			attachmentId
		},
		true
	);

	const url: string = createUrlRelativeToEnvironment(`Email/DownloadExchangeAttachment?${params}`);
	download(url);
}